module.exports = __webpack_public_path__ + "static/axaGraph-e42470a6969688c438287c64459ef1f8.jpg";